import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
// import products from '@constants/products'
import endpoint from '@constants/apipath'
import common from '@state/modules/common'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  fetchDocuments(
    { commit, dispatch, getters },
    { orderId, productId, timeZone } = {}
  ) {
    let api = getApi(productId)
    return axios
      .get(
        `${api}${
          endpoint.documentApiPath.get
        }?OrderId=${orderId}&ProductId=${productId}&TimeZone=${timeZone}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  uploadDocument({ state }, { fileDetails } = {}) {
    let api = getApi(fileDetails.ProductId)
    return axios.post(
      `${api}${endpoint.documentApiPath.upload}`,
      JSON.stringify(fileDetails),
      {
        headers: setHeaders(),
      }
    )
  },

  deleteDocument(
    { commit, dispatch, getters },
    { orderId, productId, orderFileId, timeZone } = {}
  ) {
    let api = getApi(productId)
    return axios
      .delete(
        `${api}${
          endpoint.documentApiPath.delete
        }?OrderId=${orderId}&OrderFileId=${orderFileId}&ProductId=${productId}&TimeZone=${timeZone}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },

  downloadDocument({ commit }, { orderFileId, productId } = {}) {
    let api = getApi(productId)
    return axios
      .get(
        `${api}${endpoint.documentApiPath.download}?orderFileId=${orderFileId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        var url = common.downloadFile(
          response.data.fileData,
          response.data.contentType,
          response.data.fileName
        )
        return url
      })
      .catch((error) => {
        return error
      })
  },
  getPdfData({ state }, { OrderId } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.ccrLobApiPath.getCCRPdf
        }/${OrderId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}

function getApi(productId) {
  // let api = ''
  // if (
  //   productId === products.LiensAndJudgmentsReport ||
  //   productId === products.EquifaxBPR ||
  //   productId === products.CCRInHouse
  // ) {
  //   api = `${appConfig.apiEndPoint}${endpoint.documentApiPath.ccrApi}`
  // } else {
  //   api = `${appConfig.apiEndPoint}${endpoint.documentApiPath.bcrApi}`
  // }
  return `${appConfig.apiEndPoint}${endpoint.documentApiPath.bcrApi}`
}
